import { accUserList } from "@/server/user"
const state = {
  userLists: [], 
};
const mutations = {
  SET_USER_LIST(state, data) {
    state.userLists = data;
  }
};
const actions = {
  async getUserlist({ commit, state }) {
    if (state.userLists.length > 0) {
      return state.userLists;
    }
    try {
      const res = await accUserList();
      const list = res.all || [];
      commit('SET_USER_LIST', list); // 存入 Vuex
      return list;
    } catch (err) {
      console.error("获取用户组列表失败", err);
      return [];
    }
  },
};
const getters = {
  userLists: (state) => state.userLists
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
